<button class="tab" [class.tab--active]="active">
  {{ label }}
</button>
